import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const DEFAULT_TZ = 'Asia/Colombo';

export function formatDateForDisplay(dateString, format = 'DD/MM/YYYY') {
  if (!dateString) return '';
  // dateString expected as YYYY-MM-DD (date-only)
  return dayjs.tz(dateString, DEFAULT_TZ).format(format);
}

export function toISODate(dateString) {
  if (!dateString) return '';
  return dayjs.tz(dateString, DEFAULT_TZ).format('YYYY-MM-DD');
}

export function todayISO() {
  return dayjs().tz(DEFAULT_TZ).format('YYYY-MM-DD');
}

export default { formatDateForDisplay, toISODate };
